
import Custom from './custom'

export default {
    loading:true,
    stateReload:false,
    language: 'en',
    authUser: {},
    menus: [],
    userStatusList: [],
    list: [],
    pendingMerchantList: [],
    pickupRequestList: [],
    issueRequestList: [],
    banks: [],
    hubs: [],
    zones: [],
    weightCharges: [],
    stores: [],
    reasons: [],
    merchants: [],
    riders: [],
    logisticPartners: [],
    summary: false,
    riderStatusList: Custom.riderStatusList,
    statusList: Custom.statusList,
    dateParameterList: Custom.dateParameterList,
    dateTypeList: Custom.dateTypeList,
    paymentByList: Custom.paymentByList,
    categoryList: Custom.categoryList,
    monthList: Custom.monthList,
    commonObj: {
        hasDropdownLoaded: false,
        perPage: 10,
        divisionList: [],
        districtList: [],
        thanaList: [],
        merchantList: [],
        areaList: [],
        zoneList: [],
        zoneAreaList: [],
        bankList: [],
        hubList: [],
        logisticPartnerList: [],
        riderList: [],
        reasonList: [],
        weightChargeList: [],
        issueList: [],
        roleList: []
    }
}